import {Button, message, Space, Table, Tooltip} from 'antd';
import Style from './index.module.scss';
import type {ColumnsType} from 'antd/es/table';
import {useMutation, useQuery} from 'react-query';
import {LinkButton} from 'Features/Buttons/LinkButton';
import {AgentMcp} from '../../../agentMcpService';
import useSelection from 'Utils/Hooks/useSelection';
import Title from 'Components/Title';
import React from 'react';
import DeleteConfirm from 'Components/DeleteConfirm';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import McpSelectDrawer from '../McpSelectDrawer';
import McpEditModal from '../McpEditModal';
import StatusTag from '../../../../../../../../Components/StatusTag';
import {QuestionCircleOutlined} from '@ant-design/icons';

interface Props {
    agentId: string;
}

const Index = ({agentId}: Props) => {
    const mcpSelectDrawer = useModalHandler({
        component: McpSelectDrawer,
        type: 'drawer',
    });
    const mcpEditModal = useModalHandler({
        component: McpEditModal,
    });
    const rowSelection = useSelection();

    const getData = useQuery({
        queryKey: ['McpFunction.list', agentId],
        queryFn: () => AgentMcp.list({agentId}),
    });

    const onDelete = useMutation({
        mutationFn: AgentMcp.remove,
        onSuccess: () => {
            message.success('成功!');
            rowSelection.clear();
            getData.refetch();
        },
    });

    const columns: ColumnsType<AgentMcp.List> = [
        {
            title: 'Mcp名称',
            dataIndex: 'name',
        },
        {
            title: 'Mcp Code',
            dataIndex: 'code',
        },
        {
            title: 'baseUrl',
            dataIndex: 'baseUrl',
        },
        {
            title: (
                <Space>
                    优先级
                    <Tooltip title="数字越小优先级越高">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </Space>
            ),
            dataIndex: 'priority',
        },
        {
            title: '启用状态',
            dataIndex: 'enabled',
            width: 100,
            render: (text: boolean) => <StatusTag status={text} />,
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            align: 'center',
            render: (value, record) => (
                <LinkButton
                    onClick={() => {
                        mcpEditModal.open({
                            agentId,
                            data: record,
                            onOk: () => {
                                mcpEditModal.close();
                                getData.refetch();
                            },
                        });
                    }}>
                    编辑
                </LinkButton>
            ),
        },
    ];

    function Extra() {
        return (
            <Space>
                <DeleteConfirm
                    onSuccess={() => {
                        onDelete.mutate({
                            agentId,
                            ids: rowSelection.selected,
                        });
                    }}>
                    <Button
                        disabled={rowSelection.isEmpty}
                        danger
                        ghost
                        size="small">
                        批量删除
                    </Button>
                </DeleteConfirm>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                        mcpSelectDrawer.open({
                            agentId,
                            onOk: () => {
                                mcpSelectDrawer.close();
                                getData.refetch();
                            },
                        });
                    }}>
                    新增
                </Button>
            </Space>
        );
    }

    return (
        <div className={Style.root}>
            <div className={Style.pd}>
                <Title extra={<Extra />}>Mcp</Title>
            </div>
            <Table
                rowKey="id"
                bordered
                size="small"
                columns={columns}
                dataSource={getData.data}
                loading={getData.isLoading || onDelete.isLoading}
                scroll={{x: 'max-content'}}
                pagination={false}
                rowSelection={rowSelection}
            />

            {mcpSelectDrawer.render()}
            {mcpEditModal.render()}
        </div>
    );
};

export default Index;
